import React from 'react';
import { IAuditoriaDespesaAnaliticaRelevanteResultado } from '../interfaces/IAuditoriaDespesaAnaliticaRelevante';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaDespesaAnaliticaRelevanteResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Despesas Analíticas Relevantes (RFB 3.01/3.02 > R$ 100k) — auditoria de
// materialidade/mapeamento referencial, não um tributo. Sem aplicação de multa (CPC 26).
const AuditoriaResumoDespesaAnaliticaRelevante: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.lancamentosDespesaRelevante?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Despesas Analíticas Relevantes (RFB 3.01/3.02)</h3>
      <p className='text-muted'>
        Auditoria complementar — lançamentos em conta analítica de despesa mapeada para o Plano Referencial da RFB
        (3.01/3.02) acima de R$ 100.000,00 exigem verificação de materialidade e do mapeamento referencial (CPC 26).
        Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Valor Identificado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_DESPESA_ANALITICA_RELEVANTE')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Despesas Analíticas Relevantes (RFB 3.01/3.02)</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} lançamento{totalOcorrencias === 1 ? '' : 's'} relevante{totalOcorrencias === 1 ? '' : 's'} identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa aplicável (CPC 26)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoDespesaAnaliticaRelevante;
